export default __webpack_public_path__ + "static/media/active-doctor-personal.08824dfd.svg";